import React from 'react';

import { createStore } from 'redux';
import thunk from 'redux-thunk';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import rootReducer from './store/root_reducer';
import { Provider } from 'react-redux';
import type { AnywhereListing, BuildoutListing, SortOrder } from './types';
import Layout from './components/layout';
import { processListings } from './helpers';

type AnywhereGuidMatcherProps = {
    anywhereListings: AnywhereListing[];
    buildoutListings: BuildoutListing[];
}

function AnywhereGuidMatcher({ anywhereListings, buildoutListings } : AnywhereGuidMatcherProps) {
  const sort : SortOrder = { field: 'address', direction: 'asc' };
  const searchText = '';
  const saleOrLease = 'all';
  const {
    matchedListings, unmatchedAnywhereListings, unmatchedBuildoutListings
  } = processListings(anywhereListings, buildoutListings, sort, searchText, saleOrLease);

  const store = createStore(
    rootReducer,
    {
      listings: {
        anywhereListings,
        unmatchedAnywhereListings,
        buildoutListings,
        unmatchedBuildoutListings,
        matchedListings,
        sort,
        searchText,
        saleOrLease
      }
    },
    applyMiddleware(thunk)
  );

  return (
    <Provider store={store}>
      <Layout />
    </Provider>
  );
}

export default AnywhereGuidMatcher;
